export const AUTH_INTENT_GUIDE = 'guide' as const;

export type AuthIntent = typeof AUTH_INTENT_GUIDE;

export const AUTH_ROUTES = {
  PHONE: '/auth/phone',
  VERIFY_OTP: '/auth/verify-otp',
} as const;

export const GUIDE_ENTRY_ROUTE = '/become-guide';

/** Shown when phone OTP is blocked because the number belongs to a Google account. */
export const GOOGLE_ACCOUNT_PHONE_MESSAGE =
  'You already have an account with Google. Please continue with Google Sign-In.';

export function authPhoneUrl(intent?: AuthIntent): string {
  return intent ? `${AUTH_ROUTES.PHONE}?intent=${intent}` : AUTH_ROUTES.PHONE;
}

export function parseAuthIntent(search: string): AuthIntent | undefined {
  const value = new URLSearchParams(search).get('intent');
  return value === AUTH_INTENT_GUIDE ? AUTH_INTENT_GUIDE : undefined;
}
